<div class="flex flex-row justify-between items-start z-[1000]">
  <span>{{ data.message }}</span>
  <mat-icon class="pointer" (click)="snackBarRef.dismiss()">close</mat-icon>
</div>
